<template>
  <div class="duty-box">
    <div class="duty-c" v-html='detail.content'>
    
    </div>
  </div>
</template>
<style lang="less">
@import "./../../../common/minix.less";
.duty-box {
  font-size: 26 / @rem;
}
.duty-c{
  padding: 20 / @rem;
  line-height: 36 / @rem;
}
.duty-c h2{
  font-size: 28 / @rem;
}
</style>
<script>
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      detail: {}
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      userApi.organizationdetail({ type: 4 ,name: window.decodeURI(this.$route.query.name)}).then(res => {
        this.detail = res.data;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Organization/Children/duty.vue